import React, { useEffect, useState } from 'react';
import { fileAccessApi } from '../../api/fileAccessApi';
import { resolveBackendAssetUrl } from '../../utils/apiBaseUrl';

interface ImportFileLinkProps {
  fileName?: string | null;
  fileUrl?: string | null;
  className?: string;
}

export const ImportFileLink: React.FC<ImportFileLinkProps> = ({
  fileName,
  fileUrl,
  className = 'text-blue-600 hover:underline',
}) => {
  const [href, setHref] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!fileUrl) {
      setHref('');
      setLoading(false);
      return;
    }

    if (fileUrl.startsWith('http://') || fileUrl.startsWith('https://')) {
      setHref(fileUrl);
      setLoading(false);
      return;
    }

    if (fileUrl.startsWith('s3://')) {
      let cancelled = false;
      setLoading(true);
      fileAccessApi
        .getDownloadUrl(fileUrl)
        .then((url) => {
          if (!cancelled) setHref(url);
        })
        .catch(() => {
          if (!cancelled) setHref('');
        })
        .finally(() => {
          if (!cancelled) setLoading(false);
        });
      return () => {
        cancelled = true;
      };
    }

    setHref(resolveBackendAssetUrl(fileUrl));
    setLoading(false);
  }, [fileUrl]);

  const label = fileName || 'Tải file';

  if (!fileUrl) {
    return fileName ? <span className="text-gray-600">{fileName}</span> : <span>—</span>;
  }

  if (loading) {
    return <span className="text-gray-500">{label}…</span>;
  }

  if (!href) {
    return <span className="text-gray-600">{label}</span>;
  }

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      download={fileName || undefined}
      className={className}
      title={fileName || undefined}
    >
      {label}
    </a>
  );
};

export default ImportFileLink;
